import React, { useState } from 'react';
import './index.css';
import { formatDate, isSameDay } from '../../helpers/functions';
import { chevronLeftIcon, chevronRightIcon, greyRightArrowIcon, trashIcon } from '../../assets';
import strings from '../../localization';
import { DateRangeMenuItems } from '../../helpers/statics';

const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

const DateRangeMenu = ({ setStartDate, setEndDate, startDate, endDate, getSelectedDateRange }) => {

  const menuItems = DateRangeMenuItems;

  const handleDateRangeClick = (item) => {
    setStartDate(item.startDate);
    setEndDate(item.endDate);
  }

  return (
    <div className="date-range-container-menu" >
      {menuItems.map((item) => (
        <div
          onClick={() => handleDateRangeClick(item)}
          className={(item.key === getSelectedDateRange().key) ? "date-range-container-menu-item-selected date-range-container-menu-item" : "date-range-container-menu-item"}
        >
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}

const DateRangeBottom = ({ startDate, endDate, setStartDate, setEndDate, setDateRangeOpen, getCalls }) => {

  const handleClear = () => {
    const _startDate = DateRangeMenuItems.find(item => item.key === 'all-time').startDate;
    const _endDate = DateRangeMenuItems.find(item => item.key === 'all-time').endDate;
    setStartDate(_startDate);
    setEndDate(_endDate);
  }

  return (
    <div className="date-range-bottom">
      <div className="date-range-bottom-range">
        <span>{formatDate(startDate)}</span>
        <img src={greyRightArrowIcon} alt="grey-right-arrow" />
        <span>{formatDate(endDate)}</span>
      </div>
      <div className='date-range-bottom-buttons' >
        <button onClick={handleClear} className="button-text-cta button-text-cta-medium date-range-bottom-buttons-clear">
          <img src={trashIcon} alt="clear" />
          <span>{strings.clear}</span>
        </button>
        <button onClick={() => setDateRangeOpen(false)} className="button-cta button-cta-medium">
          <span>{strings.cancel}</span>
        </button>
        <button onClick={getCalls} className="button-cta-secondary button-cta-secondary-medium">
          <span>{strings.setDate}</span>
        </button>
      </div>
    </div>
  )
}

export default function CustomDateRange({ setStartDate, setEndDate, startDate, endDate, setDateRangeOpen, getCalls, getSelectedDateRange }) {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(new Date(today.getFullYear(), today.getMonth(), 1));



  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

  const handlePrevMonth = () => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    if (!startDate || (startDate && endDate)) {
      setStartDate(date);
      setEndDate(null);
    } else if (date < startDate) {
      setStartDate(date);
      setEndDate(null);
    } else {
      setEndDate(date);
    }
  };

  const isInRange = (date) => {
    return startDate && endDate && date > startDate && date < endDate;
  };

  const isToday = (date) => {
    return isSameDay(date, today);
  };

  const renderDays = () => {
    const days = [];
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDayIndex = new Date(year, month, 1).getDay();
    const daysInMonth = getDaysInMonth(year, month);
    const prevLastDate = new Date(year, month, 0).getDate();

    // Önceki aydan birkaç gün
    for (let i = firstDayIndex; i > 0; i--) {
      days.push(
        <div key={`prev-${i}`} className="day faded">
          {prevLastDate - i + 1}
        </div>
      );
    }

    for (let d = 1; d <= daysInMonth; d++) {
      const currentDate = new Date(year, month, d);
      const selectedStart = isSameDay(currentDate, startDate);
      const selectedEnd = isSameDay(currentDate, endDate);
      const inRange = isInRange(currentDate);
      const isTodayDate = isToday(currentDate);

      let className = 'day';
      if (selectedStart || selectedEnd) className += ' selected';
      else if (inRange) className += ' in-range';
      if (isTodayDate) className += ' today';

      days.push(
        <div
          key={d}
          className={className}
          onClick={() => handleDateClick(currentDate)}
        >
          <span>{d}</span>
        </div>
      );
    }

    return days;
  };

  const monthName = currentMonth.toLocaleString('default', { month: 'long' });
  const year = currentMonth.getFullYear();

  return (
    <div className='date-range-container' >
      <DateRangeMenu setStartDate={setStartDate} setEndDate={setEndDate} startDate={startDate} endDate={endDate} getSelectedDateRange={getSelectedDateRange} />
      <div className="date-range-container-outer">
        <div className="calendar-container">
          <div className="calendar-header">
            <button className="button-text-cta" onClick={handlePrevMonth}>
              <img src={chevronLeftIcon} alt="chevron-left" />

            </button>
            <div className="calendar-title">{`${monthName.toUpperCase()} ${year}`}</div>
            <button className="button-text-cta" onClick={handleNextMonth}>
              <img src={chevronRightIcon} alt="chevron-right" />
            </button>
          </div>

          <div className="weekdays">
            {weekDays.map((day, i) => (
              <div key={i} className="weekday"><span>{day}</span></div>
            ))}
          </div>

          <div className="calendar-grid">
            {renderDays()}
          </div>
        </div>
        <DateRangeBottom startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} setDateRangeOpen={setDateRangeOpen} getCalls={getCalls} />
      </div>
    </div>
  );
}
